import Button from "src/components/Button";
import Modal from "src/components/Modal/Modal";
import useLoader from "src/hooks/useLoader";
import { declineJobApplication } from "src/network/job_application";

interface IDeclineApplicationModal {
  id?: number;
  close: () => void;
  onDecline: () => void;
}

const DeclineApplicationModal = ({ id, close, onDecline }: IDeclineApplicationModal) => {
  const { ldng, loading } = useLoader(() => declineJobApplication(id || -1), {
    errorMsg: "Error declining talent",
    successMsg: "Talent was declined"
  });
  if (!id) return null;

  const decline = async () => {
    await ldng();
    onDecline();
  };

  return (
    <Modal
      onChange={close}
      open={true}
      className="!w-[500px] flex flex-col items-center justify-center gap-6 text-center"
    >
      <p className="font-poppins text-xl font-semibold">Are you sure to decline this request?</p>
      <p className="text-base leading-[32px] text-[#8A8A8A] font-medium">
        Only eligible candidates can be considered. Declined candidates cannot be reconsidered for
        this role.
      </p>
      <div className="flex gap-6">
        <Button onClick={close} shapeVariant={2} variant="white_gray">
          Cancel
        </Button>
        <Button
          className="!min-w-[109px] !h-[56px]"
          onClick={decline}
          shapeVariant={2}
          loading={loading}
          variant="red"
        >
          Decline
        </Button>
      </div>
    </Modal>
  );
};

export default DeclineApplicationModal;
